export default __webpack_public_path__ + "static/media/phonebooth_mobile.f7d8209d.webp";